import { useMutation } from 'convex/react';
import { api } from 'convex/_generated/api';
import type { Id } from 'convex/_generated/dataModel';

export function useUpdateUserPlant() {
  return useMutation(api.plants.mutations.updateUserPlant).withOptimisticUpdate(
    (localStore, args) => {
      const current = localStore.getQuery(api.plants.queries.getAllPlants, {});
      if (current === undefined) return;

      const plantId = String(args.userPlantId);
      const name = args.name.trim();
      if (!name) return;

      localStore.setQuery(
        api.plants.queries.getAllPlants,
        {},
        current.map((plant) =>
          plant.id === plantId
            ? {
                ...plant,
                name,
                emoji: args.emoji.trim() || '🌱',
                category: args.category.trim() || 'Other',
                speciesName: name,
                isUserOwned: true,
              }
            : plant
        )
      );
    }
  );
}

export type UpdateUserPlantArgs = {
  userPlantId: Id<'userPlants'>;
  name: string;
  emoji: string;
  category: string;
};
